import { useEffect, useState } from "react";
import { resolveTimezone, timezoneLabel } from "./timezone";

/** Track server offset and tick every second for a live clock. */
export function useSyncedClock(serverIso) {
  const [offsetMs, setOffsetMs] = useState(0);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!serverIso) return;
    const serverMs = new Date(serverIso).getTime();
    if (!Number.isNaN(serverMs)) {
      setOffsetMs(serverMs - Date.now());
    }
  }, [serverIso]);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  // tick drives a re-render every second while offsetMs keeps server alignment
  void tick;
  return new Date(Date.now() + offsetMs);
}

export function formatLiveClock(date, timezone, { showZone = true } = {}) {
  if (!date || Number.isNaN(date.getTime())) return "—";
  const tz = resolveTimezone(timezone);
  try {
    const clock = new Intl.DateTimeFormat("en-GB", {
      timeZone: tz,
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);
    if (!showZone) return clock;
    return `${clock} ${timezoneLabel(tz)}`;
  } catch {
    return date.toUTCString();
  }
}

export function formatDualClock(date, eventTimezone) {
  const eventTz = resolveTimezone(eventTimezone);
  const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone || eventTz;
  const eventLabel = formatLiveClock(date, eventTz);
  if (localTz === eventTz) return eventLabel;
  const localLabel = formatLiveClock(date, localTz, { showZone: false });
  return `${eventLabel} · local ${localLabel}`;
}
